import React from 'react';
import { motion } from 'framer-motion';

const PrivateFeedback = () => {
  return (
    <section className="w-full py-12 px-6 bg-padua-lightSage/20 rounded-3xl border border-padua-sage/10 text-center">
      <div className="max-w-2xl mx-auto">
        <h3 className="font-serif text-2xl md:text-3xl text-padua-dark mb-4">Need Help With Something?</h3>
        <p className="text-padua-dark/70 font-light leading-relaxed mb-8">
          If there’s something our team can help with from your experience, we’d be grateful for the chance to hear from you directly.
        </p>
        <motion.a
          href="mailto:info@paduaweddings.com?subject=Padua%20Experience%20Feedback"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="inline-block px-8 py-3 rounded-full border border-padua-olive text-padua-olive font-medium hover:bg-padua-olive hover:text-white transition-all duration-300"
        >
          Contact the Padua Team
        </motion.a>
      </div>
    </section>
  );
};

export default PrivateFeedback;